import Heading from 'LuxKit/Typography/Heading'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import clsx from 'clsx'
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &.has-image{
    justify-content: flex-start;
  }
`

interface Props {
  destination: string
  hasImage: boolean
}

export function ResultsFilteredByDestination({ destination, hasImage }: Props) {
  return (
    <Container className={clsx({ 'has-image': hasImage })}>
      <Heading as="span" colour="dark-contrast" variant="heading1">
        <FormattedMessage
          id="jIos59ddut_12ViooA5h"
          defaultMessage="Travel inspiration in <i>{destination}</i>"
          description="Hero heading for holiday type landing page filtered by destination"
          values={{
            destination,
            i: (chunks) => <i>{chunks}</i>,
          }}
        />
      </Heading>
    </Container>
  )
}
